import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { FiltersPanel } from 'page/catalog/DemoCatalogFilters/FiltersPanel'
import { StandGenders } from 'page/catalog/StandGenders/StandGenders'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const BasicFilters = observer(() => {
  const demo = useDemo()
  const { options } = demo
  const { ready, genders } = options
  const { search } = demo.product

  if (!ready && !search) return null

  return (
    <Vertical gap={16} pad={[0, 16]}>
      {genders && <StandGenders />}
      <FiltersPanel />
    </Vertical>
  )
})
